import { Col, Row } from "antd";
import Form from "common/Form";
import FilledButton from "common/Form/Button";
import TextInput from "common/Form/TextInput";
import Layout from "common/Layout";
import { jwtDecode } from "jwt-decode";
import React, { useCallback, useEffect, useState } from "react";
import {
  RiEyeFill,
  RiEyeOffFill,
  RiLock2Fill,
  RiUserFill,
} from "react-icons/ri";
import { useNavigate } from "react-router-dom";

const EyeIcon = ({ open, onClick }) => {
  const props = {
    onClick: onClick,
    style: {
      cursor: "pointer",
      color: "var(--detail)",
    },
  };
  return open ? <RiEyeFill {...props} /> : <RiEyeOffFill {...props} />;
};

export default function Login({ ...props }) {
  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [passwordShown, setPasswordShown] = useState(false);
  const [error, setError] = useState("");

  const togglePasswordShown = () => setPasswordShown(!passwordShown);

  const redirect = useCallback(() => {
    try {
      const jwt = sessionStorage.getItem("auth");
      const decoded = jwtDecode(jwt);
      decoded.role === "ADMIN" ? navigate("/manager") : navigate("/reviewer");
    } catch {}
  }, [navigate]);

  const authenticate = (callback) => {
    setError("");
    fetch(`${process.env.REACT_APP_API}/auth`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ username, password }),
    })
      .then((res) => {
        if (!res.ok) {
          throw new Error("El usuario o constraseña ingresados no son válidos");
        }
        return res.text();
      })
      .then((res) => sessionStorage.setItem("auth", res))
      .then((res) => navigate(0))
      .catch((err) => {
        setError(err.message);
        if (callback) callback();
      });
  };

  useEffect(() => {
    redirect();
  }, [redirect]);

  return (
    <Layout
      headerLeftButton={{ content: "¿Qué es ValBIM?", onClick: () => {} }}
      headerRightButton={{ content: "¿Cómo funciona?", onClick: () => {} }}
    >
      <Row justify="center" style={{ height: "100%" }} align="middle">
        <Col lg={12}>
          <h1 className="text-center">Bienvenido a ValBIM</h1>

          <hr />

          <p>
            Plataforma de validación automática para modelos BIM IFC que verifica el
            cumplimiento de reglas técnicas, normativas urbanísticas y
            estándares empresariales.
          </p>
          <ul>
            <li>Valida proyectos BIM en minutos</li>
            <li>Utiliza estándar IFC Open Source</li>
            <li>Configurable y adaptable</li>
            <li>Sin necesidad de expertos</li>
          </ul>

          <Form
            values={(username, password)}
            onChange={({ username, password }) => {
              username !== undefined && setUsername(username);
              password !== undefined && setPassword(password);
            }}
            onSubmit={authenticate}
          >
            <TextInput
              name="username"
              label="Usuario"
              startIcon={
                <RiUserFill
                  style={{
                    color: "var(--color-1)",
                  }}
                />
              }
            />
            <TextInput
              name="password"
              label="Contraseña"
              startIcon={
                <RiLock2Fill
                  style={{
                    color: "var(--color-1)",
                  }}
                />
              }
              type={passwordShown ? "text" : "password"}
              endIcon={
                <EyeIcon open={!passwordShown} onClick={togglePasswordShown} />
              }
            />

            {error && (
              <Row justify="center" style={{ marginTop: 16 }}>
                <Col lg={24}>
                  <div
                    style={{
                      color: "#ff4d4f",
                      textAlign: "center",
                      fontSize: 14,
                    }}
                  >
                    {error}
                  </div>
                </Col>
              </Row>
            )}

            <Row justify="center" style={{ marginTop: 48 }}>
              <Col lg="auto">
                <FilledButton green onClick={authenticate}>
                  Ingresar
                </FilledButton>
              </Col>
            </Row>
          </Form>
        </Col>
      </Row>
    </Layout>
  );
}
